export default __webpack_public_path__ + "static/media/DSC00005.6e3263a6.JPG";